import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import homeimg from "../../../assets/images/home.png";
const HomeMain = styled("section")(({ theme }) => ({
  paddingTop: "60px",
  [theme.breakpoints.down("sm")]: {
    paddingTop: "20px",
  },
  [theme.breakpoints.up("md")]: {
    paddingTop: "20px",
  },
  [theme.breakpoints.up("lg")]: { paddingTop: "60px" },
}));

const HomeBGWrap = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    "&::after": {
      content: "none",
    },
  },
  [theme.breakpoints.up("md")]: {
    height: "auto",
  },
  [theme.breakpoints.up("lg")]: {
    height: "600px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      right: 0,
      width: "100%",
      height: "100%",
      backgroundImage: `url(${homeimg})`,
      backgroundSize: "contain",
      backgroundPosition: "bottom right",
      backgroundRepeat: "no-repeat",
      zIndex: "-1",
    },
  },
}));

const TextImageWrap = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0px",
  },
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
  },
  paddingTop: "5rem",
  paddingLeft: "20px",
}));

const TextImage = styled("img")({
  maxWidth: "100%",
  height: "auto",
});

const Title = styled("h6")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "38px",
  lineHeight: "62px",
  fontFamily: theme.typography.fontFamily,
  textTransform: "capitalize",
  color: theme.palette.colors.BlackBean,
  paddingLeft: "20px",
  marginTop: "-20px",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0px",
    fontSize: "24px",
  },
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
    fontSize: "24px",
  },
}));
const Details = styled("p")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  paddingLeft: "20px",
  paddingTop: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "22px",
  lineHeight: "33px",
  textAlign: "justify",
  color: "rgba(11, 11, 11, 0.6)",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0px",
    fontSize: "16px",
    lineHeight: "22px",
  },
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
    fontSize: "16px",
    lineHeight: "22px",
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  background: theme.palette.primary.main,
  borderRadius: "10px",
  textDecoration: "none",
  transition: "all 0.2s ease-in-out",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "20px",
  lineHeight: "20px",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  width: "200px",
  height: "50px",
  marginLeft: "20px",
  marginTop: "40px",
  "& svg": {
    fontSize: "20px",
  },
  "&:hover": {
    background: "rgb(51, 51, 51)",
  },
  [theme.breakpoints.down("sm")]: {
    marginLeft: "0px",
    fontSize: "16px",
    lineHeight: "22px",
    marginBottom: "5rem",
  },
  [theme.breakpoints.down("md")]: {
    marginLeft: "0px",
    fontSize: "16px",
    lineHeight: "22px",
    marginBottom: "5rem",
  },
}));

export {
  HomeMain,
  HomeBGWrap,
  TextImageWrap,
  TextImage,
  Title,
  Details,
  StyledLink,
};
